module.exports = __webpack_public_path__ + "static/media/service2.aaf7afa0.svg";